import React, { Component } from 'react'
import { connect } from 'react-redux'

import Modal from '../Shared/Modal'
import ModalHeader from '../Shared/ModalHeader'
import ModalButtonStrip from '../Shared/ModalButtonStrip'
import ModalBody from '../Shared/ModalBody'
import ModalFooter from '../Shared/ModalFooter'
import BoxButton from '../Layout/BoxButton'

import {
    showHideModalFilter,
    addModalFilterCriteria,
    removeCheckedModalFilterCriterias,
    toggleCheckedModalFilterCriterias,
    updateModalFilterCriteria,
    applyFilterCriterias,
} from '../../actions/plantillas'

import { operators } from '../../utils/helpers'
import { tableCols } from '../../containers/Plantillas'

class ModalFilter extends Component {
    handleCloseModal = (e) => {
        const modal = document.getElementById('modalFilter')
        modal.classList.remove('fadeIn')
        modal.classList.add('fadeOut')

        const modalDialog = document.querySelector(`#modalFilter .modal-dialog`)
        modalDialog.classList.remove('zoomIn')
        modalDialog.classList.add('zoomOut')

        setTimeout(() => this.props.showHideModalFilter(false), 300)
    }

    handleApplyFilters = (e) => {
        this.handleCloseModal()
        this.props.applyFilterCriterias()
    }

    render() {
        const { modalFilter } = this.props
        if (!modalFilter.get('show')) {
            return null
        }
        return(
            <Modal id="modalFilter" show={ true } ZIndex={ 2000 }>
                <ModalHeader title="Filtro" onClose={ e => this.handleCloseModal(e, "modalFilter") } />
                <ModalButtonStrip>
                    <BoxButton name="plus" onClick={ e => this.props.addModalFilterCriteria() } title="Aceptar" />
                    <BoxButton name="trash" onClick={ e => this.props.removeCheckedModalFilterCriterias() } disabled={ modalFilter.get('filters').filter(item => item.get('checked')).count() === 0 } title="Eliminar" />
                    <BoxButton name="check" onClick={ e => this.handleApplyFilters() } title="Aceptar" />
                </ModalButtonStrip>
                <ModalBody>
                    <div style={{ width: '600px' }}>
                        <div className="row">
                            <div className="col-lg-12" style={{ height: '200px', overflowX: 'hidden' }}>
                                <table className="table table-bordered table-condensed">
                                    <thead>
                                        <tr>
                                            <th style={{ width: '20px' }}></th>
                                            <th>Columna</th>
                                            <th>Operador</th>
                                            <th>Filtro</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            modalFilter.get('filters').count() > 0 ? modalFilter.get('filters').map((item, index) => {
                                                const key = `tr2[${index}]`
                                                return (
                                                    <tr key={ key } className={ `${ item.get('checked') ? 'info' : '' }` }>
                                                        <td style={{ verticalAlign: 'middle' }}><input type="checkbox" onChange={ e => this.props.toggleCheckedModalFilterCriterias(index, e.target.checked) } checked={ item.get('checked') } /></td>
                                                        <td>
                                                            <select className="form-control input-sm" value={ item.get('column') } onChange={ e => this.props.updateModalFilterCriteria(index, 'column', e.target.value) }>
                                                                {
                                                                    tableCols.map((x1, n1) => {
                                                                        return (
                                                                            <option key={ `opt1[${x1.Id}][${n1}]` } value={ x1.Value }>{ x1.Caption }</option>
                                                                        )
                                                                    })
                                                                }
                                                            </select>
                                                        </td>
                                                        <td>
                                                            <select className="form-control input-sm" value={ item.get('operator') } onChange={ e => this.props.updateModalFilterCriteria(index, 'operator', e.target.value) }>
                                                                {
                                                                    operators.filter(x => x.comparisons.includes(item.get('comparison'))).map((item1, n) => {
                                                                        return (
                                                                            <option key={ `opt2[${item1.id}][${n}]` } value={ item1.value }>{ item1.caption }</option>
                                                                        )
                                                                    })
                                                                }
                                                            </select>
                                                        </td>
                                                        <td>
                                                            <input type="text" className="form-control input-sm" value={ item.get('value') } onChange={ e => this.props.updateModalFilterCriteria(index, 'value', e.target.value) } />
                                                        </td>
                                                    </tr>
                                                )
                                            }) : <tr><td colSpan="4" style={{ textAlign: 'center' }}>No hay filtros</td></tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                </ModalFooter>
            </Modal>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        modalFilter: state.plantillas.get('modalFilter'),
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        showHideModalFilter: (state) => dispatch(showHideModalFilter(state)),
        addModalFilterCriteria: () => dispatch(addModalFilterCriteria()),
        removeCheckedModalFilterCriterias: () => dispatch(removeCheckedModalFilterCriterias()),
        toggleCheckedModalFilterCriterias: (index, checked) => dispatch(toggleCheckedModalFilterCriterias(index, checked)),
        updateModalFilterCriteria: (index, attr, value) => dispatch(updateModalFilterCriteria(index, attr, value)),
        applyFilterCriterias: () => dispatch(applyFilterCriterias()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalFilter)


// WEBPACK FOOTER //
// ./src/components/Plantillas/ModalFilter.jsx